import { useState } from 'react';
import type { FundLineForm } from './calculator.types';
import { createEmptyFundLine } from './calculator.utils';

export const useFundLines = (onChange?: () => void) => {
  const [fundLines, setFundLines] = useState<FundLineForm[]>([
    createEmptyFundLine(),
  ]);

  const updateFundLine = (index: number, updates: Partial<FundLineForm>) => {
    setFundLines((previous) =>
      previous.map((line, lineIndex) =>
        lineIndex === index ? { ...line, ...updates } : line,
      ),
    );
    onChange?.();
  };

  const addFundLine = () => {
    setFundLines((previous) => [...previous, createEmptyFundLine()]);
    onChange?.();
  };

  const removeFundLine = (index: number) => {
    setFundLines((previous) =>
      previous.length <= 1
        ? previous
        : previous.filter((_, lineIndex) => lineIndex !== index),
    );
    onChange?.();
  };

  const resetFundLines = () => {
    setFundLines([createEmptyFundLine()]);
  };

  return {
    addFundLine,
    fundLines,
    removeFundLine,
    replaceFundLines: setFundLines,
    resetFundLines,
    updateFundLine,
  };
};
